export default __webpack_public_path__ + "static/media/vinpearl-logo-1@2x.753efee9.svg";